/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_ToolsInputs */



/**
* | output |
* | --- |
* | "CSV downloads, filters and /stats in Discord" |
*
* @param {Pricing_Compare_ToolsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_tools = /** @type {((inputs?: Pricing_Compare_ToolsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_ToolsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выгрузка в CSV, фильтры и /статистика в Discord")
	return /** @type {LocalizedString} */ ("CSV downloads, filters and /stats in Discord")
});